import { useEffect, useMemo } from "react";
import { useProjectActions, useProjectContext } from "@contexts/projects";
import { useDashboardUIContext } from "@contexts/dashboardUI";
import TableItem from "./TableItem";
import ProjectionLoadState from "../ProjectionLoadState";

const ServiceAccordion = ({ parent }) => {

  const { barChartDate } = useDashboardUIContext()
  const { activeProject: { _id, services = {} }, filterDates } = useProjectContext();
  const { loadServices } = useProjectActions();

  useEffect(() => {
    if (_id) {
      loadServices(parent, barChartDate);
    }
  }, [_id, filterDates, barChartDate])

  const substepServices = useMemo(() => services[parent], [services, parent])

  return (
    <>
      <ProjectionLoadState
        level="services"
        parent={parent}
        isMissing={!substepServices}
        onRetry={() => loadServices(parent, barChartDate)}
      />
      {substepServices?.map((item, index) => <TableItem key={index} item={item} type={"service"} typeTitle={"Serviço"} />)}
    </>
  )
}

export default ServiceAccordion;
